import { render } from "./GenerateReportsDialog.vue?vue&type=template&id=2bf0a2d4&scoped=true"
import script from "./GenerateReportsDialog.vue?vue&type=script&lang=js"
export * from "./GenerateReportsDialog.vue?vue&type=script&lang=js"

import "./GenerateReportsDialog.vue?vue&type=style&index=0&id=2bf0a2d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf0a2d4"]])

export default __exports__